// extracted by mini-css-extract-plugin
var _1 = "_collateralApprovalTableSearchAndFilterBar-module__content-container";
var _2 = "_collateralApprovalTableSearchAndFilterBar-module__input";
export { _1 as "content-container", _2 as "input" }
